import script from "./HomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeView.vue?vue&type=script&lang=ts&setup=true"

import "./HomeView.vue?vue&type=style&index=0&id=090a2200&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090a2200"]])

export default __exports__